<template>
    <div class="error">


        <b-row align-v="center" align-h="center">
            <b-col md="5">

                <h1 class="text-center">Beklager</h1>
                <p class="text-center">
                    {{ description || "En feil har oppstått. Kontakt oss eller forsøk på nytt." }}
                </p>

            </b-col>

        </b-row>


    </div>
</template>


<script>

export default {
    name: 'Login',
    props: {
      description: String,
    },
    data() {
        return {
        }
    },
    mounted() {



    },
    methods: {

    }
}
</script>


<style scoped lang="scss">

</style>
